import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { validateYouTubeUrl } from '@/util/utils';
export const Url = ({ url, title, onClick }) => {
    const validYoutubeUrl = validateYouTubeUrl(url);
    return (_jsx(_Fragment, { children: !validYoutubeUrl ? (_jsx("a", { className: "text-accent align-middle no-underline transition-colors duration-250 ease-out", href: url, target: "_blank", onClick: () => onClick({
                type: 'url',
                label: title || url,
                value: url,
            }), rel: "noreferrer", children: title || url })) : (_jsx("iframe", { id: title, title: title, width: "100%", height: "265", frameBorder: "0", allowFullScreen: true, src: validYoutubeUrl, className: "h-full w-full border-none" })) }));
};
